"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("core-js/modules/es6.function.name");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectSpread15 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _account = _interopRequireDefault(require("@sfly/uig-svg-icon/account/account"));

var _account_selected = _interopRequireDefault(require("@sfly/uig-svg-icon/account/account_selected"));

var _projects = _interopRequireDefault(require("@sfly/uig-svg-icon/account/projects"));

var _projects_selected = _interopRequireDefault(require("@sfly/uig-svg-icon/account/projects_selected"));

var _group_v = _interopRequireDefault(require("@sfly/uig-svg-icon/account/group_v2"));

var _group_v2_selected = _interopRequireDefault(require("@sfly/uig-svg-icon/account/group_v2_selected"));

var _photos = _interopRequireDefault(require("@sfly/uig-svg-icon/photos/photos"));

var _photos_selected = _interopRequireDefault(require("@sfly/uig-svg-icon/photos/photos_selected"));

var _uigCartCount = _interopRequireDefault(require("@sfly/uig-cart-count"));

var _Utils = _interopRequireDefault(require("../common/util/Utils"));

var _uigBreakpoints = require("@sfly/uig-breakpoints");

var _myProjects_selected = _interopRequireDefault(require("@sfly/uig-svg-icon/my-projects/my-projects_selected"));

var _myProjects = _interopRequireDefault(require("@sfly/uig-svg-icon/my-projects/my-projects"));

var _uigCdnLibraries = require("@sfly/uig-cdn-libraries");

var _dropdown = _interopRequireDefault(require("@sfly/uig-svg-icon/action/dropdown"));

var _uigTooltipDropdownMenu = _interopRequireDefault(require("@sfly/uig-tooltip-dropdown-menu"));

var _uigButton = require("@sfly/uig-button");

var _fetchCartCount = _interopRequireDefault(require("../common/fetchCartCount"));

var _queryString = _interopRequireDefault(require("query-string"));

var _helperUtil = require("../common/util/helperUtil");

var _constants = require("../constants");

require("./PersonalToolbar.css");

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
} //Variables for URLs


var URL_ORDER_HISTORY = '/account/orderhistory.jsp';
var URL_PROJECTS = "https://www.".concat((0, _helperUtil.getEnvPrefix)(), "shutterfly.com/mySavedProjects");
var URL_FAVORITES = '/favoritesList/view.sfly';
var URL_SETTINGS = "/account-settings";
var URL_SIGN_UP = "https://www.".concat((0, _helperUtil.getEnvPrefix)(), "shutterfly.com/signupconfirmation");
var URL_SIGN_OUT = '/signout/start.sfly';
var URL_ADDRESS_BOOK = '/addressbook/management.sfly';
var URL_LIFETOUCH = '/lifetouch-pictures/#/personalize';
var URL_PHOTOS = "https://photos.".concat((0, _helperUtil.getEnvPrefix)(), "shutterfly.com/?brand=");

var PersonalToolbar = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PersonalToolbar, _Component);

  var _super = _createSuper2(PersonalToolbar);

  function PersonalToolbar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PersonalToolbar);
    _this = _super.call(this, props); // Add event handler to hide dropdown when you click other things.

    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "trackParams", function (linkId) {
      return {
        'data-link-id': linkId,
        'data-link-module': 'global-header',
        'data-link-module-type': 'top-nav',
        'data-link-module-position': 'none'
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onLoggedInDropdownKeyDown", function (event) {
      if (_Utils.default.filterKeyPress(event, [_Utils.default.keyCodeMap.space])) {
        event.preventDefault();
      } else if (_Utils.default.filterKeyPress(event, [_Utils.default.keyCodeMap.escape])) {
        event.preventDefault();

        _this.closeLoggedInDropdown();

        if (typeof document !== 'undefined') {
          document.getElementById('user-menu').focus();
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "generateMenuConfig", function () {
      var _this$props = _this.props,
          activeLink = _this$props.activeLink,
          currentBrand = _this$props.currentBrand,
          enableMyPhotosLink = _this$props.enableMyPhotosLink,
          enableShareSitesLink = _this$props.enableShareSitesLink,
          enableCartLink = _this$props.enableCartLink;
      return {
        'My Account': {
          liClassName: "myAccountLink-container desktop-only uig-toolbar-menu",
          isVisible: false,
          spanClassName: "myAccount-link",
          activeClassName: activeLink === 'myAccount' ? 'active' : '',
          name: "My Account",
          iconName: "MyAccountIcon",
          linkAttr: (0, _objectSpread15.default)({
            title: "View your recent activity, track your orders and manage your account."
          }, _this.trackParams("My Account"), {
            className: activeLink === 'myAccount' ? 'active' : '',
            href: _this.getHref('/myaccount/?brand=' + currentBrand),
            onClick: function onClick(event) {
              _this.checkForHistoryAndRedirect(event, '/myaccount/?brand=' + currentBrand);
            },
            onKeyPress: function onKeyPress(e) {
              _this.handlePersonalToolbarOptionKeyPress(e);
            },
            'aria-label': "My Account"
          })
        },
        'My Projects': {
          liClassName: "myProjectsLink-container desktop-only uig-toolbar-menu",
          isVisible: true,
          spanClassName: "myProjects-link",
          activeClassName: activeLink === 'myProjects' ? 'active' : '',
          name: "My Projects",
          iconName: "MyProjectsIcon",
          linkAttr: (0, _objectSpread15.default)({}, _this.trackParams("My Projects"), {
            'data-linkname': "Desktop | My Projects",
            className: activeLink === 'myProjects' ? 'active' : '',
            href: URL_PROJECTS,
            onClick: function onClick(event) {
              _this.checkForHistoryAndRedirect(event, URL_PROJECTS);
            },
            onKeyPress: function onKeyPress(e) {
              _this.handlePersonalToolbarOptionKeyPress(e);
            },
            'aria-label': "My Projects"
          })
        },
        'My Photos': {
          liClassName: "desktop-only uig-toolbar-menu",
          isVisible: enableMyPhotosLink,
          spanClassName: "myPhotos-link",
          activeClassName: activeLink === 'myPhotos' ? 'active' : '',
          name: "My Photos",
          iconName: "PhotosIcon",
          linkAttr: (0, _objectSpread15.default)({
            title: "View, organize and edit your photos."
          }, _this.trackParams("My Photos"), {
            className: activeLink === 'myPhotos' ? 'active' : '',
            href: URL_PHOTOS + currentBrand,
            onClick: _this.handleSecuredLinksClick,
            onKeyPress: function onKeyPress(e) {
              _this.handlePersonalToolbarOptionKeyPress(e);
            },
            'aria-label': "My Photos"
          })
        },
        'Share Sites': {
          liClassName: "shareSitesLink-container desktop-only uig-toolbar-menu",
          isVisible: enableShareSitesLink,
          spanClassName: "shareSites-link",
          activeClassName: activeLink === 'shareSites' ? 'active' : '',
          name: "Share Sites",
          iconName: "GroupIcon",
          linkAttr: (0, _objectSpread15.default)({
            title: "View your Share sites"
          }, _this.trackParams("Share Sites"), {
            className: activeLink === 'shareSites' ? 'active' : '',
            href: _this.getHref('/nav/share.sfly?brand=' + currentBrand),
            onClick: function onClick(event) {
              _this.handleSecuredLinksClick(event, false, false);
            },
            onKeyPress: function onKeyPress(e) {
              _this.handlePersonalToolbarOptionKeyPress(e, false, false);
            },
            'aria-label': "Share Sites"
          })
        },
        'Cart': {
          liClassName: "cartLink-container uig-toolbar-menu",
          isVisible: enableCartLink,
          spanClassName: "cartLink",
          activeClassName: activeLink === 'cart' ? 'active' : '',
          name: "Cart",
          iconName: "CartCountIcon",
          linkAttr: (0, _objectSpread15.default)({}, _this.trackParams("Cart"), {
            className: activeLink === 'cart' ? 'active' : '',
            href: _this.getHref('/cart?brand=' + currentBrand),
            onClick: _this.handleSecuredLinksClick,
            onKeyPress: function onKeyPress(e) {
              _this.handlePersonalToolbarOptionKeyPress(e);
            },
            'aria-label': _this.state.fetchedCartCount ? _this.state.fetchedCartCount + ' items added in Cart' : 'Cart'
          })
        }
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeLoggedInDropdown", function () {
      _this.setState({
        dropdownExpanded: false
      });
    });
    _this.onDocumentClickListener = _this.onDocumentClickListener.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSigninClick = _this.handleSigninClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSignupClick = _this.handleSignupClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSecuredLinksClick = _this.handleSecuredLinksClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.onDropDownLinkClick = _this.onDropDownLinkClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.getCartCount = _this.getCartCount.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSignInKeyPress = _this.handleSignInKeyPress.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSignUpKeyPress = _this.handleSignUpKeyPress.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      user: null,
      jwtToken: null,
      dropdownExpanded: _this.props.dropdownExpanded,
      iconsMouseOverState: {
        AccountIcon: false,
        MyAccountIcon: false,
        GroupIcon: false,
        PhotosIcon: false,
        CartCountIcon: false
      }
    };
    return _this;
  }

  (0, _createClass2.default)(PersonalToolbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event listener for clicking outside the drop down
      if (typeof document !== 'undefined') {
        document.addEventListener('click', this.onDocumentClickListener);
      }

      if (typeof window !== 'undefined') {
        window.addEventListener('cartCountUpdate', this.getCartCount, false);
      }

      this.getCartCount();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var shouldFetchCartCount = !prevProps.jwtToken && this.props.jwtToken && this.props.fetchCartCount;

      if (shouldFetchCartCount) {
        this.getCartCount();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event listener for clicking outside the drop down
      if (typeof document !== 'undefined') {
        document.removeEventListener('click', this.onDocumentClickListener);
      }

      if (typeof window !== 'undefined') {
        window.removeEventListener('cartCountUpdate', this.getCartCount);
      }
    }
  }, {
    key: "onDocumentClickListener",
    value: function onDocumentClickListener(e) {
      // Hide the drop down if it is showing and we clicked somewhere else in the DOM
      if (this.state.dropdownExpanded) {
        this.setState({
          dropdownExpanded: false
        });
      }
    }
  }, {
    key: "handleIconMouseEvents",
    value: function handleIconMouseEvents(event, iconName) {
      event.preventDefault();

      if (event.type === 'mouseenter' && !this.state.iconsMouseOverState[iconName]) {
        this.setState(function (currentState) {
          return currentState.iconsMouseOverState[iconName] = true;
        });
      } else if (event.type === 'mouseleave' && this.state.iconsMouseOverState[iconName]) {
        this.setState(function (currentState) {
          return currentState.iconsMouseOverState[iconName] = false;
        });
      }
    }
  }, {
    key: "getHref",
    value: function getHref(relativePath) {
      var sflyBaseUrl = "".concat(_Utils.default.getSFLYHostNameBasedonBrand(this.props.currentBrand));
      return "".concat(sflyBaseUrl).concat(relativePath);
    }
  }, {
    key: "loggedInDropdown",
    value: function loggedInDropdown() {
      var _this2 = this;

      return _react.default.createElement(_uigBreakpoints.Media, {
        min: "lg",
        render: function render() {
          return _react.default.createElement(_uigTooltipDropdownMenu.default, {
            anchorRight: true
          }, _react.default.createElement("ul", {
            className: "logged-in-dropdown-list",
            onClick: function onClick(e) {
              return e.nativeEvent.stopImmediatePropagation();
            },
            onKeyDown: _this2.onLoggedInDropdownKeyDown
          }, _this2.dropdownOptions()));
        }
      });
    }
  }, {
    key: "handleSignInKeyPress",
    value: function handleSignInKeyPress(e) {
      if (_Utils.default.filterKeyPress(e, [_Utils.default.keyCodeMap.enter])) {
        this.handleSigninClick(e);
      } else if (_Utils.default.filterKeyPress(e, [_Utils.default.keyCodeMap.space])) {
        e.preventDefault();
      }
    }
  }, {
    key: "handleSignUpKeyPress",
    value: function handleSignUpKeyPress(e) {
      if (_Utils.default.filterKeyPress(e, [_Utils.default.keyCodeMap.enter])) {
        this.handleSignupClick(e);
      } else if (_Utils.default.filterKeyPress(e, [_Utils.default.keyCodeMap.space])) {
        e.preventDefault();
      }
    }
  }, {
    key: "checkForHistoryAndRedirect",
    value: function checkForHistoryAndRedirect(event, url) {
      if (this.props.history) {
        event.preventDefault();
        this.closeLoggedInDropdown();
        this.props.history.push(url);
      } else {
        this.handleSecuredLinksClick(event);
      }
    }
  }, {
    key: "dropdownOptions",
    value: function dropdownOptions() {
      var _this3 = this;

      var buttonOptions = [],
          loggedIn = !!this.props.userFirstName || !!this.state.jwtToken;

      var isExtraOptionsValidArr = _Utils.default.isValidArray(this.props.extraDropdownOptions);

      if (!loggedIn) {
        buttonOptions.push(_react.default.createElement("li", {
          key: "signin-button"
        }, _react.default.createElement(_uigButton.PrimaryButton, (0, _extends2.default)({
          role: "button",
          tabIndex: "0"
        }, this.trackParams('Sign In'), {
          onClick: this.handleSigninClick,
          onKeyPress: this.handleSignInKeyPress,
          "aria-label": "Sign In"
        }), "Sign In")));
        buttonOptions.push(_react.default.createElement("li", {
          key: "signup-button"
        }, _react.default.createElement(_uigButton.SecondaryButton, (0, _extends2.default)({
          role: "button",
          tabIndex: "0"
        }, this.trackParams('Sign Up'), {
          onClick: this.handleSignupClick,
          onKeyPress: this.handleSignUpKeyPress,
          "aria-label": "Sign Up"
        }), "Sign Up")));
      }

      var options = {
        "order-history": (0, _objectSpread15.default)({
          label: "Order History",
          href: this.getHref(URL_ORDER_HISTORY),
          onClick: this.handleSecuredLinksClick
        }, this.trackParams('Order History'), {
          'aria-label': "Order History"
        }),
        // Changes related to permanently displaying My Projects in PT & My Accounts in dropdown 
        "my-projects": (0, _objectSpread15.default)({
          label: "My Projects",
          href: this.getHref(URL_PROJECTS),
          hideOption: true,
          onClick: function onClick(event) {
            _this3.checkForHistoryAndRedirect(event, URL_PROJECTS);
          }
        }, this.trackParams('My Projects'), {
          'aria-label': "My Projects",
          liClassName: 'my-projects-user-menu-option'
        }),
        "my-account": (0, _objectSpread15.default)({
          label: "My Account",
          href: this.getHref('/myaccount/?brand=' + this.props.currentBrand),
          onClick: function onClick(event) {
            _this3.checkForHistoryAndRedirect(event, '/myaccount/?brand=' + _this3.props.currentBrand);
          }
        }, this.trackParams('My Account'), {
          'aria-label': "My Account",
          liClassName: 'my-account-user-menu-option'
        }),
        "settings": (0, _objectSpread15.default)({
          label: "Settings",
          href: this.getHref(URL_SETTINGS),
          onClick: function onClick(event) {
            _this3.handleSecuredLinksClick(event, true);
          }
        }, this.trackParams('Settings'), {
          'aria-label': "Settings"
        }),
        "lifetouch": (0, _objectSpread15.default)({
          label: "Lifetouch",
          href: this.getHref(URL_LIFETOUCH),
          onClick: this.handleSecuredLinksClick
        }, this.trackParams('Lifetouch'), {
          'aria-label': "Lifetouch"
        }),
        "address-book": (0, _objectSpread15.default)({
          label: "Address Book",
          href: this.getHref(URL_ADDRESS_BOOK),
          onClick: this.handleSecuredLinksClick,
          onKeyDown: function onKeyDown(e) {
            if (!e.shiftKey && !_Utils.default.filterKeyPress(e, [_Utils.default.keyCodeMap.space]) && !loggedIn && !isExtraOptionsValidArr) {
              setTimeout(_this3.closeLoggedInDropdown, 100);
            }
          }
        }, this.trackParams('Address Book'), {
          'aria-label': "Address Book"
        })
      };
      options = (0, _keys.default)(options).map(function (key) {
        var values = options[key];

        if (values.hideOption) {
          return null;
        }

        return _react.default.createElement("li", {
          key: key,
          className: values.liClassName
        }, _react.default.createElement("a", values, values.label));
      });

      if (isExtraOptionsValidArr) {
        options.push(_react.default.createElement("li", {
          className: "divider",
          key: "extra-divider"
        }));

        var _loop = function _loop(index) {
          var option = _this3.props.extraDropdownOptions[index];
          options.push(_react.default.createElement("li", {
            key: option.text
          }, _react.default.createElement("a", (0, _extends2.default)({
            href: "".concat(option.url)
          }, _this3.trackParams(option.text), option.attrs, {
            onKeyDown: function onKeyDown(e) {
              if (index == _this3.props.extraDropdownOptions.length - 1 && !e.shiftKey && !loggedIn) {
                setTimeout(_this3.closeLoggedInDropdown, 100);
              }
            },
            "aria-label": option.text
          }), option.text)));
        };

        for (var index in this.props.extraDropdownOptions) {
          _loop(index);
        }
      }

      if (loggedIn) {
        options.push(_react.default.createElement("li", {
          className: "divider",
          key: "signout-divider"
        }));
        options.push(_react.default.createElement("li", {
          key: "sign-out"
        }, _react.default.createElement("a", {
          href: this.getHref("".concat(URL_SIGN_OUT, "?brand=").concat(this.props.currentBrand)),
          onKeyDown: function onKeyDown(e) {
            if (!e.shiftKey && !_Utils.default.filterKeyPress(e, [_Utils.default.keyCodeMap.space])) {
              setTimeout(_this3.closeLoggedInDropdown, 100);
            }
          },
          "aria-label": "Sign out"
        }, "Sign out")));
      }

      return [].concat(buttonOptions, (0, _toConsumableArray2.default)(options));
    }
  }, {
    key: "renderMenuContent",
    value: function renderMenuContent(menuName) {
      var _this$props2 = this.props,
          activeLink = _this$props2.activeLink,
          projectCnt = _this$props2.projectCnt;

      if (menuName === "My Account") {
        return _react.default.createElement(_react.default.Fragment, null, this.state.iconsMouseOverState.MyAccountIcon || activeLink === 'myAccount' ? _react.default.createElement(_projects_selected.default, {
          className: "accountIcon"
        }) : _react.default.createElement(_projects.default, {
          className: "accountIcon"
        }), _react.default.createElement("span", null, menuName));
      } else if (menuName === "My Projects") {
        var label = projectCnt > 0 ? menuName + '(' + projectCnt + ')' : menuName;
        return _react.default.createElement(_react.default.Fragment, null, this.state.iconsMouseOverState.MyProjectsIcon || activeLink === 'myProjects' ? _react.default.createElement(_myProjects_selected.default, {
          className: "accountIcon"
        }) : _react.default.createElement(_myProjects.default, {
          className: "accountIcon"
        }), _react.default.createElement("span", null, label));
      } else if (menuName === "My Photos") {
        return _react.default.createElement(_react.default.Fragment, null, this.state.iconsMouseOverState.PhotosIcon || activeLink === "My Photos" ? _react.default.createElement(_photos_selected.default, {
          className: "accountIcon"
        }) : _react.default.createElement(_photos.default, {
          className: "accountIcon"
        }), _react.default.createElement("span", {
          className: "my-photos-label"
        }, _react.default.createElement("span", {
          className: "my-photos-label-my"
        }, "My"), " Photos"));
      } else if (menuName === "Share Sites") {
        return _react.default.createElement(_react.default.Fragment, null, this.state.iconsMouseOverState.GroupIcon || activeLink === 'shareSites' ? _react.default.createElement(_group_v2_selected.default, {
          className: "groupIcon"
        }) : _react.default.createElement(_group_v.default, {
          className: "groupIcon"
        }), _react.default.createElement("span", null, "Share Sites"));
      } else if (menuName === "Cart") {
        return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_uigCartCount.default, {
          size: "30px",
          className: "cart-icon",
          textLength: this.state.fetchedCartCount && this.state.fetchedCartCount > 9 ? '37' : '35',
          count: this.state.fetchedCartCount,
          isHighlighted: this.state.iconsMouseOverState.CartCountIcon || activeLink === 'cart'
        }), _react.default.createElement("span", {
          className: "cartLink-label"
        }, "Cart"));
      }
    }
  }, {
    key: "renderMenuItems",
    value: function renderMenuItems(menuData) {
      var _this4 = this;

      var spanClassName = menuData.spanClassName,
          name = menuData.name,
          iconName = menuData.iconName,
          activeClassName = menuData.activeClassName,
          linkAttr = menuData.linkAttr;
      return _react.default.createElement("span", {
        className: "menu-item ".concat(spanClassName, " ").concat(activeClassName),
        onMouseEnter: function onMouseEnter(event) {
          _this4.handleIconMouseEvents(event, iconName);
        },
        onMouseLeave: function onMouseLeave(event) {
          _this4.handleIconMouseEvents(event, iconName);
        }
      }, _react.default.createElement("a", linkAttr, this.renderMenuContent(name)));
    }
  }, {
    key: "handleSigninClick",
    value: function handleSigninClick(evt) {
      evt.preventDefault();
      var signinForwardUrl = this.props.signinForwardUrl;
      this.directToSflyAuth(signinForwardUrl, false, false);
    }
  }, {
    key: "handleSignupClick",
    value: function handleSignupClick(evt) {
      evt.preventDefault();
      var signupForwardUrl = this.props.signupForwardUrl;
      var params = (0, _helperUtil.getQueryStringParameters)(typeof window !== 'undefined' ? window.location.href : '');
      var ssoPayload = (0, _objectSpread15.default)({
        redirectUri: encodeURI(signupForwardUrl)
      }, this.getSingleSignOnBrandAndTheme(false), {
        ssoAction: true,
        cid: params.CID || params.cid || ''
      });

      if (typeof window !== 'undefined' && window.$sflyAuth) {
        window.$sflyAuth.showSignUp(ssoPayload);
      }
    }
  }, {
    key: "handleSecuredLinksClick",
    value: function handleSecuredLinksClick(evt) {
      var checkElevation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var checkAuth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      evt.preventDefault();
      var targetUrl = evt.currentTarget.href;

      if (typeof window === 'undefined') {
        return;
      }

      if (checkAuth && window.$sflyAuth) {
        if (!this.state.jwtToken) {
          this.directToSflyAuth(targetUrl);
        } else if (checkElevation && window.$sflyAuth.isElevationNeeded()) {
          this.directToSflyAuth(targetUrl, true);
        } else {
          window.location.href = targetUrl;
        }
      } else {
        window.location.href = targetUrl;
      }
    }
  }, {
    key: "directToSflyAuth",
    value: function directToSflyAuth(redirectUri) {
      var elevationNeeded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var forceIncTheme = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var params = (0, _helperUtil.getQueryStringParameters)(typeof window !== 'undefined' ? window.location.href : '');
      var ssoPayload = (0, _objectSpread15.default)({
        redirectUri: encodeURI(redirectUri),
        cid: params.CID || params.cid || ''
      }, this.getSingleSignOnBrandAndTheme(forceIncTheme));

      if (typeof window !== 'undefined' && window.$sflyAuth) {
        if (elevationNeeded) {
          window.$sflyAuth.requireElevation(ssoPayload);
        } else {
          window.$sflyAuth.showSignIn(ssoPayload);
        }
      }
    }
    /**
     * Since the main website supports 3 brands (inc, sfly, and tp) and the SSO SPA
     * supports 5 (sfly, tp, mlt, preschools, and prestige), we are doing a little mapping from
     * the "logo brand" of "INC" to "SFLY" for the brand value in the payload.
     *
     * The SSO "theme" can be overridden independently of the sso "brand".
     * In the SSO/Cognito world the follow holds true...
     * brand === database (customer ownership alignment and payouts)
     * theme === logos and css (look and feel since we have integrations which third parties)
     *
     * @see constants/index.js for acceptable values
     *
     */

  }, {
    key: "getSingleSignOnBrandAndTheme",
    value: function getSingleSignOnBrandAndTheme() {
      var forceIncTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var brand = this.props.currentBrand === _constants.BRANDS.INC ? _constants.BRANDS.SHUTTERFLY : this.props.currentBrand;
      var theme = this.props.ssoTheme ? this.props.ssoTheme : this.props.currentBrand; // If the theme is not SFLY and we need elevation, we will force the THEME to be INC since this is what is desired from product

      if (forceIncTheme) {
        theme = _constants.SSO_THEMES.INC;
      }

      return {
        brand: brand,
        theme: theme
      };
    }
  }, {
    key: "onDropDownLinkClick",
    value: function onDropDownLinkClick(e) {
      var openDropDown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !this.state.dropdownExpanded;
      e.nativeEvent.stopImmediatePropagation();
      this.setState({
        dropdownExpanded: openDropDown
      });
    }
  }, {
    key: "getCartCount",
    value: function () {
      var _getCartCount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var cartCount;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.props.jwtToken && this.props.fetchCartCount)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return (0, _fetchCartCount.default)(this.props.jwtToken);

              case 3:
                cartCount = _context.sent;
                this.setState({
                  fetchedCartCount: cartCount
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCartCount() {
        return _getCartCount.apply(this, arguments);
      }

      return getCartCount;
    }()
  }, {
    key: "dropdownLink",
    value: function dropdownLink() {
      var _this5 = this;

      var activeLink = this.props.activeLink;
      var loggedIn = !!this.props.userFirstName || !!this.state.jwtToken;
      var firstName;

      if (loggedIn) {
        firstName = this.props.userFirstName || this.state.user && this.state.user.given_name;

        if (!firstName) {
          (0, _helperUtil.consoleLog)('warning: user.firstName is missing in PersonalToolbar component');
        }
      }

      var activeClassName = loggedIn && activeLink === 'signedIn' || !loggedIn && activeLink === 'signIn' ? 'active' : '';
      return _react.default.createElement("span", null, _react.default.createElement("span", {
        className: "menu-item desktop-only ".concat(activeClassName),
        onMouseEnter: function onMouseEnter(event) {
          _this5.handleIconMouseEvents(event, 'AccountIcon');
        },
        onMouseLeave: function onMouseLeave(event) {
          _this5.handleIconMouseEvents(event, 'AccountIcon');
        }
      }, _react.default.createElement("a", (0, _extends2.default)({
        onClick: function onClick(e) {
          return _this5.onDropDownLinkClick(e);
        },
        onKeyPress: function onKeyPress(event) {
          return _Utils.default.handleKeyPress(event, function () {
            _this5.onDropDownLinkClick(event);
          });
        },
        onKeyDown: function onKeyDown(e) {
          (e.shiftKey || _Utils.default.filterKeyPress(e, [_Utils.default.keyCodeMap.escape])) && _this5.closeLoggedInDropdown();
        },
        tabIndex: "0",
        "aria-label": "User Menu",
        role: "button",
        "aria-haspopup": "true",
        "aria-expanded": this.state.dropdownExpanded
      }, this.trackParams('Sign in menu'), {
        id: "user-menu"
      }), this.state.iconsMouseOverState.AccountIcon || loggedIn && activeLink === 'signedIn' || !loggedIn && activeLink === 'signIn' ? _react.default.createElement(_account_selected.default, {
        className: "accountIcon"
      }) : _react.default.createElement(_account.default, {
        className: "accountIcon"
      }), loggedIn && _react.default.createElement(_react.Fragment, null, _react.default.createElement("span", {
        className: "accountIcon-label uig-account-container"
      }, _react.default.createElement("span", {
        className: "uig-hello-text"
      }, firstName && "Hi, ".concat(firstName), !firstName && 'Welcome'), _react.default.createElement(_dropdown.default, {
        className: "dropdown-icon"
      }))), !loggedIn && _react.default.createElement("span", {
        className: "signIn-label"
      }, "Sign in"))), this.state.dropdownExpanded && this.loggedInDropdown());
    }
  }, {
    key: "handlePersonalToolbarOptionKeyPress",
    value: function handlePersonalToolbarOptionKeyPress(event) {
      var checkElevation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var checkAuth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (_Utils.default.filterKeyPress(event, [_Utils.default.keyCodeMap.space])) {
        event.preventDefault();
      } else if (_Utils.default.filterKeyPress(event, [_Utils.default.keyCodeMap.enter])) {
        event.preventDefault();
        this.handleSecuredLinksClick(event, checkElevation, checkAuth);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var menuItems = this.generateMenuConfig();
      return _react.default.createElement("ul", {
        className: "uig-uni-header-menu-items",
        "aria-label": "personal toolbar"
      }, _react.default.createElement("li", {
        className: "dropdownLink-container desktop-only"
      }, this.dropdownLink()), (0, _keys.default)(menuItems).map(function (key) {
        var menu = menuItems[key];
        var liClassName = menu.liClassName,
            isVisible = menu.isVisible;
        return isVisible && _react.default.createElement("li", {
          key: key,
          className: liClassName
        }, _this6.renderMenuItems(menu));
      }), this.props.children && _react.default.createElement("li", {
        className: "hamburger-mobileonly"
      }, _react.default.createElement(_react.Fragment, null, _react.Children.toArray(this.props.children))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref, state) {
      var user = _ref.user,
          jwtToken = _ref.jwtToken;
      return {
        user: user,
        jwtToken: jwtToken
      };
    }
  }]);
  return PersonalToolbar;
}(_react.Component);

PersonalToolbar.propTypes = {
  currentBrand: _propTypes.default.oneOf([_constants.BRANDS.SHUTTERFLY, _constants.BRANDS.TINYPRINTS, _constants.BRANDS.INC]),
  ssoTheme: _propTypes.default.oneOf([_constants.SSO_THEMES.SHUTTERFLY, _constants.SSO_THEMES.TINYPRINTS, _constants.SSO_THEMES.INC, _constants.SSO_THEMES.LTI, _constants.SSO_THEMES.MLT, _constants.SSO_THEMES.PRESCHOOLS, _constants.SSO_THEMES.PRESTIGE]),
  user: _propTypes.default.shape({
    firstName: _propTypes.default.string
  }),
  fetchCartCount: _propTypes.default.bool,
  enableMyAccountLink: _propTypes.default.bool,
  enableMyProjectsLink: _propTypes.default.bool,
  enableMyPhotosLink: _propTypes.default.bool,
  enableShareSitesLink: _propTypes.default.bool,
  enableCartLink: _propTypes.default.bool,
  extraDropdownOptions: _propTypes.default.arrayOf(_propTypes.default.string),
  activeLink: _propTypes.default.oneOf(['signIn', 'signedIn', 'myAccount', 'myProjects', 'myPhotos', 'shareSites', 'cart', 'none']),
  jwtToken: _propTypes.default.string,
  dropdownExpanded: _propTypes.default.bool,
  children: _propTypes.default.any,
  signinForwardUrl: _propTypes.default.string,
  signupForwardUrl: _propTypes.default.string,
  userFirstName: _propTypes.default.string,
  history: _propTypes.default.any
};
PersonalToolbar.defaultProps = {
  currentBrand: _constants.BRANDS.INC,
  ssoTheme: null,
  user: null,
  fetchCartCount: true,
  enableMyAccountLink: true,
  enableMyProjectsLink: true,
  enableMyPhotosLink: true,
  enableShareSitesLink: true,
  enableCartLink: true,
  extraDropdownOptions: null,
  activeLink: 'none',
  dropdownExpanded: false,
  signinForwardUrl: typeof window !== 'undefined' ? window.location.href : '',
  signupForwardUrl: URL_SIGN_UP,
  userFirstName: '',
  history: null
};
var _default = PersonalToolbar;
exports.default = _default;